import React from 'react';
import PropTypes from 'prop-types';

import styles from './Button.module.scss';

function Button({ children, className, color, type, ...buttonProps }) {
  const buttonClasses = [styles.button, className];
  switch (color) {
    case 'success':
      buttonClasses.push(styles.success);
      break;
    case 'transparent':
      buttonClasses.push(styles.transparent);
      break;
    default:
  }

  return (
    <button type={type} className={buttonClasses.join(' ')} {...buttonProps}>
      {children}
    </button>
  );
}

Button.defaultProps = {
  className: '',
  color: '',
  disabled: false,
  onClick: null,
  type: 'button',
};

Button.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
};

export default Button;
